import { api } from "./customers";

export interface Customer {
  customerName: string;
  source: any;
  status: boolean;
  hospital_code: any;
  customerId: number;
  appointmentDate: any;
  appointmentTime: any;
  email: string;
  phoneNumber: number;
  branchName: string;
  mobileNo: number;
  emailId: string;
  address: string;
  id: number;
}

export interface HospitalAppointment {
  status: string;
  message: string;
  data: Customer[];
}

type AppointmentByIdResponse = HospitalAppointment[];

export const HospitallandingApi = api.injectEndpoints({
  endpoints: (build) => ({
    getHospitalsDetails: build.query<AppointmentByIdResponse, string>({
      query: (id) => `hospital/${id}`,
      transformResponse: (response: any, meta, arg) =>
      response,
      providesTags: (result, error, id) => [{ type: "Hosp", id }],
    }),
    getAdminProcedures: build.query<any,any>({
      query: (id) =>
          `procedure-tittle-only?branchId=${id}`,
    }),    
    getBranchProcedures: build.query<any,any>({
      query: () =>
          `procedure-tittle-only`,
    }),          
  }),
});

export const {
  useGetHospitalsDetailsQuery,
  useGetAdminProceduresQuery,
  useGetBranchProceduresQuery
} = HospitallandingApi;
